import { StatusCritical } from 'grommet-icons';

export function Status({ type, children, ...props }) {
  switch (type) {
    case 'critical':
      return <StatusCritical {...props}>{children}</StatusCritical>;
  }
}
